/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AnaphylaxisRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      batches: this.store.findAll('medical/batch'),
      medications: this.store
        .findAll('medical/medication')
        .then((medications) => {
          return medications.filter((medication) => medication.person_id);
        }),
    });
  }
}
